export default "__VITE_ASSET__D0lLke17__"